import React, { Component } from 'react';
import SignUp from './SignUp';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import Verify from './Verify';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import loginImg from '../../images/img_login.png';
import signupImg from '../../images/img_signup.png';

import { clearAuthError } from '../../actions/auth';

function backgroundStyle(authType) {
  const bgStyle = {
    backgroundImage: `url(${signupImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center'
  };
  if (authType === 'login') {
    bgStyle.backgroundImage = `url(${loginImg})`;
  }
  return bgStyle;
}

class Auth extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { authType, signedIn } = this.props;
    if (signedIn) {
      return <Redirect to='/' />;
    }
    return (
      <>
        <div className='fe-auth-container'>
          {/* <div className="fe-auth-background" style={backgroundStyle(authType)} /> */}
          <div className='container'>
            <div className='row'>
              <div className='col-12'>
                <div className='fe-auth-content'>
                  {
                    {
                      signup: <SignUp />,
                      login: <Login />,
                      verify: <Verify />,
                      resetPassword: <ForgotPassword />
                    }[authType]
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

Auth.propTypes = {
  authType: PropTypes.string.isRequired,
  signedIn: PropTypes.bool.isRequired,
  clearAuthError: PropTypes.func.isRequired
};

const mapStateToProps = ({ authState }) => ({
  signedIn: authState.signedIn
});

const mapDispatchToProps = {
  clearAuthError
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Auth);
